import { ApplicationCredentialType, getApplicationSecretName } from '../secrets/actions'
import { getActiveRegion } from 'api-client/helpers'

interface OpenStackClusterBodyParams {
  name: string
  namespace: string
  network: string
  subnet: string
  openstackCluster: string
}

export const createKaapiOpenStackClusterBody = ({
  name,
  namespace,
  network,
  subnet,
  openstackCluster,
}: OpenStackClusterBodyParams) => {
  return {
    apiVersion: 'infrastructure.cluster.x-k8s.io/v1beta1',
    kind: 'OpenStackCluster',
    metadata: {
      name,
      namespace,
      labels: {
        'pcd-kaapi.pf9.io/region': getActiveRegion(),
      },
    },
    spec: {
      apiServerLoadBalancer: {
        enabled: false,
      },
      network: { id: network },
      subnets: [{ id: subnet }],
      controlPlaneAvailabilityZones: [openstackCluster],
      disableAPIServerFloatingIP: true,
      disableExternalNetwork: true,
      apiServerFixedIP: '',
      identityRef: {
        name: getApplicationSecretName(ApplicationCredentialType.IdentityRef),
        cloudName: 'openstack',
      },
      managedSecurityGroups: {
        allowAllInClusterTraffic: true,
        allNodesSecurityGroupRules: [
          {
            remoteManagedGroups: ['worker'],
            direction: 'ingress',
            etherType: 'IPv4',
            name: 'BGP',
            portRangeMin: 179,
            portRangeMax: 179,
            protocol: 'tcp',
            description: 'Allow BGP among workers',
          },
          {
            remoteManagedGroups: ['worker'],
            direction: 'ingress',
            etherType: 'IPv4',
            name: 'IP-in-IP',
            protocol: '4',
            description: 'Allow IP-in-IP among workers',
          },
          {
            remoteIPPrefix: '0.0.0.0/0',
            direction: 'ingress',
            etherType: 'IPv4',
            name: 'SSH',
            portRangeMin: 22,
            portRangeMax: 22,
            protocol: 'tcp',
            description: 'Allow SSH',
          },
        ],
      },
    },
  }
}
